import React from 'react';
import { TableCell, Box } from '@mui/material';
import { AppDataContext } from '../../context/Context';

export default class GridUploadWrapCell extends React.Component {
    static contextType = AppDataContext;

    constructor(props) {
        super(props);
        this.state = {
            images: {}
        };
    }

    componentDidMount() {
        this.preloadImages();
    }

    async preloadImages() {
        const { value } = this.props;
        const files = Array.isArray(value) ? value : [value];

        for (let fileWrapper of files) {
            if (!fileWrapper.file) continue;
            const fileData = await this.context
                .getState()
                .server.files.getFile(fileWrapper.file.name);

            if (fileData.error !== 'OK') {
                console.error('Error loading file', fileData.error);
                continue;
            }

            const imageURL = URL.createObjectURL(fileData.blob);
            this.setState((prevState) => ({
                images: {
                    ...prevState.images,
                    [fileWrapper.file.name]: imageURL
                }
            }));
        }
    }

    renderFilePreview(fileName) {
        const imageURL = this.state.images[fileName];
        if (!imageURL) return null;

        return (
            <img
                src={imageURL}
                alt={fileName}
                style={{ width: '50px', height: '50px' }}
            />
        );
    }

    render() {
        const { value, field } = this.props;
        const files = Array.isArray(value) ? value : [value];

        return (
            <TableCell key={field.id} align="left">
                {files.map((fileWrapper, index) => {
                    if (fileWrapper.file) {
                        if (index > 2) {
                            return (
                                <Box key={index}>
                                    <span>...</span>
                                </Box>
                            );
                        }
                        return (
                            <Box key={index}>
                                {this.renderFilePreview(fileWrapper.file.name)}
                            </Box>
                        );
                    } 
                    return null;
                    
                })}
            </TableCell>
        );
    }
}
